import * as yup from 'yup'

/**
 * Mirrors the backend `UpdateRetryConfigDto` exactly.
 *
 * `maxAttempts`, `backoffMultiplier`, and `timeoutMinutes` are `@IsPositive` server-side —
 * strictly greater than zero, so `0` is rejected the same way the API would reject it
 * (`.positive()`, not `.min(0)`).
 *
 * `currentAttempt` is `@IsNumber @Min(0)` — unlike the three above, `0` IS valid here, so it
 * uses `.min(0)` instead of `.positive()`. Getting these two rules swapped is the bug this form
 * exists to avoid.
 *
 * `.integer()` is NOT from the DTO — `@IsPositive` / `@Min(0)` both accept `2.5`. It comes from
 * the database: all four are `@Column({ nullable: false })` on a `number` in
 * `RetryActionConfigEntity`, which TypeORM maps to an INTEGER column, so a fractional value
 * would be truncated or rejected by Postgres after passing DTO validation. That includes
 * `backoffMultiplier` — the column is an int, so there is no 1.5x backoff to be had.
 *
 * The `transform` mirrors `UpdateRetryTemplateModal.validator.ts`'s pattern: a cleared MUI
 * number input leaves `''` in Formik state, and `yup.number()` would otherwise cast that to
 * `NaN` and fail with a type error instead of the friendlier required message.
 */
export const editActionConfigValidator = yup.object({
  maxAttempts: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),

  backoffMultiplier: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),

  timeoutMinutes: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .positive('Must be greater than 0')
    .required('Required'),

  currentAttempt: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .typeError('Enter a number')
    .integer('Must be a whole number')
    .min(0, 'Must be 0 or greater')
    .required('Required'),
})
